import { CHECKOUT_CREDITS_ENABLED } from "./config";

// The fixed vocabulary of the studio: which product types exist, what each type
// may sell, and how those things are labelled. Behaviour lives in the step
// components; this file only says what the options ARE.

// Sellable types first, coming-soon ones after, so no disabled pill sits between
// the two an admin can actually pick.
export const TYPE_PILLS = [
  { value: "plan", label: "Plan" },
  { value: "ads", label: "Ad Credits" },
  { value: "webinar", label: "Webinar", disabled: true },
  { value: "physical", label: "Physical Goods", disabled: true },
];

// `ads` sells credits only, so it hides with the credits flag. Render sites read
// this; TYPE_PILLS stays intact.
export const VISIBLE_TYPE_PILLS = TYPE_PILLS.filter(
  (t) => CHECKOUT_CREDITS_ENABLED || t.value !== "ads"
);

// Which entitlement cards each product type may offer.
const ALLOWED_ENTITLEMENTS = {
  plan: ["subscription", "credits"],
  webinar: ["webinar"],
  ads: ["credits"],
  physical: [],
};
export const allows = (type, ent) => (ALLOWED_ENTITLEMENTS[type] || []).includes(ent);

// Same gating for the entitlement cards: render sites read this, not
// ALLOWED_ENTITLEMENTS.
export const entitlementsFor = (type) =>
  (ALLOWED_ENTITLEMENTS[type] || []).filter(
    (ent) => CHECKOUT_CREDITS_ENABLED || ent !== "credits"
  );

export const CREDIT_FIELDS = [
  { k: "ctwaAmount", name: "Meta Ads credits", note: "for running click-to-WhatsApp ads" },
  { k: "wccAmount", name: "Conversation credits", note: "for WhatsApp conversation charges" },
];

// A credits-blueprint field -> its pricing line id, and the reverse.
export const CREDIT_LINE = { ctwaAmount: "credit_ctwa", wccAmount: "credit_wcc" };
export const REV_CREDIT = { credit_ctwa: "ctwaAmount", credit_wcc: "wccAmount" };

// `ads` products sell only Meta Ads credits; every other type offers all three.
export const creditFieldsFor = (type) =>
  type === "ads" ? CREDIT_FIELDS.filter((c) => c.k === "ctwaAmount") : CREDIT_FIELDS;

// What the buyer sees next to the price ("₹24,000 Billed yearly"). Derived from
// the period rather than typed, so it can't go stale when the period changes.
export const BILLING_LABEL = {
  monthly: "Billed monthly",
  quarterly: "Billed quarterly",
  yearly: "Billed yearly",
  oneTime: "One-time payment",
};
export const billingLabelFor = (period) => BILLING_LABEL[period] || "";

// One line each, shown under the family name in the Add-ons section.
export const ADDON_DESC = {
  flow_addon: "Visual chatbot flows",
  team_members: "Extra seats on the workspace",
  ai_messages: "Message packs for AI replies",
};
